<template>
  <div class="main-body">
    <div class="header">护理项目</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" @change="ins_change" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-select v-model="nursingTypeCode" clearable  placeholder="选择护理类型" style="margin:0 10px;">
            <el-option
                v-for="item in nursingTypeValue"
                :key="item.nursingTypeCode"
                :label="item.name"
                :value="item.nursingTypeCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                :height="th" border >

        <el-table-column prop="name" label="名称" ></el-table-column>
        <el-table-column prop="nursingTypeName" label="护理类型" ></el-table-column>

        <el-table-column prop="status" label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">正常</span>
            <span v-if="scope.row.status == 1">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" ></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:arr_ins="arr_ins"
         v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:arr_ins="arr_ins"
          v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Edit from "./Edit";
import Add from "./Add";

export default {
  name: "Page",
  data(){
    return{
      loading:false,

      showModalAdd:false,
      showModalEdit:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      nursingTypeValue:[],
      nursingTypeCode:'',

      th:0,

      arr_ins:[],
      institutionCode: '',

    }
  },
  components:{
    Add,Edit
  },
  created(){
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:3,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getNursingTypeList();
            //this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    ins_change(val){
      this.institutionCode = val;

      this.nursingTypeValue = [];
      this.nursingTypeCode = '';
      this.getNursingTypeList();
    },

    getNursingTypeList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'NursingType/InsList',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
        }
      }).then((response) => {
        //console.log(response.data);
        if (response.data.error == 0) {
          this.nursingTypeValue = response.data.data;
          if(this.nursingTypeValue.length>0){
            this.nursingTypeCode = this.nursingTypeValue[0].nursingTypeCode;
            this.getList();
          }
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index,row) {
      this.showModalEdit = !this.showModalEdit;
      this.$refs.myEdit.init(row);
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingItem/GovPageIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          nursingTypeCode:this.nursingTypeCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        //console.log(response);
        this.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style lang="scss" scoped>

</style>
